// import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import FullWidthHeaderAdvanced from "@components/BasicComponents/FullWidthHeader/FullWidthHeaderAdvanced"
import Separator from "@components/CustomTypography/Separator/Separator"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import PageSubNavigation from "@components/WebsiteRevamp/PageSubNavigation/PageSubNavigation"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import CareersData from "@jsons/careers.json"
import CareersCounts from "@pages/Careers/CareersCounts/CareersCounts"
import CareersFeature from "@pages/Careers/CareersFeature/CareersFeature"
import UnderVideoSection from "@pages/Careers/CareersUnderVideo/UnderVideoSection"
import InBriefSection from "@pages/Careers/InBriefSection"
import StoriesListSection from "@pages/Careers/StoriesListSection"
import React from "react"

type Props = {}

const careers = (props: Props): any => {
	const pageData = getTranslatedPageData(CareersData, true, true)
	const CareerPage = getValueOrThrow(pageData.AdvancedSideAsset)
	const subMenu = getValueOrThrow(pageData.subMenu)

	return (
		<>
			<HeadMeta meta={pageData.metaData} customPath="/careers" />

			{/* <FullWidthHeader
				data={getValueOrThrow(CareerPage[0].mainContent)[0]}
				position={"left"}
				size={"L"}
			/> */}
			{/* <FullWidthHeaderAdvanced
				data={getValueOrThrow(pageData.heroData?.[0])}
				withOverlay 
			/>*/}

			<FullWidthHeader
				data={{
					title: pageData.heroData?.[0].title,
					subtitle: pageData.heroData?.[0].subtitle,
					buttons: pageData.heroData?.[0].buttons,
				}}
				position={"left"}
				size={"L"}
			/>
			<Separator size={16} />
			<PageSubNavigation data={subMenu} />

			<UnderVideoSection data={CareerPage[1]} />
			{/* <ContainerWrapper>
				<Divider thickness={"2px"} />
			</ContainerWrapper> */}
			{/* <CultureSection data={CareerPage[2]} /> */}

			<CareersFeature data={CareerPage[3]} />

			<StoriesListSection data={CareerPage[4]} />

			<InBriefSection data={CareerPage[5]} />

			<CareersCounts data={CareerPage[6]} withoutAsset />

			{/* <OurValueSection data={CareerPage[7]} /> */}
			{/* 
			<CareersHiring data={CareerPage[8]} />

			<PositionsSection
				categories={translatedJobCategories}
				jobs={positionsData}
				locations={transLocaitonsCategories}
				table={CareerPage[10]}
			/> */}
			{/* <Separator size={128} /> */}

			{/* <BottomSection data={CareerPage[9]} /> */}
		</>
	)
}

export default careers
